// Bronce Interiors — Mega Menu Hover Image Swap + Accordion Animation
// Paste this into: Online Store → Themes → Edit code → Assets → bronce-mega-menu-hover.js
// Then add this line in your theme.liquid before </body>:
// <script src="{{ 'bronce-mega-menu-hover.js' | asset_url }}" defer></script>
 
(function () {
 
  // ── IMAGE MAP ──────────────────────────────────────────────────────────────
  const images = {
    'by-finish':  [
      'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/BronceInteriors_BobbinHandle_800x800.jpg?v=1779070566',
      'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/S2e4f0340dbe741158f9c241d4b9057a7K_800x800.jpg?v=1778204972',
      'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/A947bda7ee31b47409ff237dfedd1a9a3z_800x800.webp?v=1778204929',
      'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/BronceInteriors_SingleCabinetPull_800x800.jpg?v=1779070566',
    ],
    'by-texture': [
      'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/par-handles-and-knobs-collection-236469_800x800.jpg?v=1778204930',
      'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/S40f756ebee8540a7ab9ff9fab1a84d0fn_800x800.jpg?v=1778204976',
      'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/S43ec608d20e046139ba177a3d2c33059N_800x800.webp?v=1778204938',
      'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/main-image-5_3_462eb6cf-79f7-48c2-9150-92087e9ec73e_800x800.jpg?v=1778204848',
    ],
    'by-room': [
      'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/BronceInteriors_BathroomAccessories_800x800.jpg?v=1779070566',
      'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/liv-knobs-collection-221918_800x800.jpg?v=1778204893',
      'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/description-image-4_63_800x800.jpg?v=1778204837',
      'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/d24284a1-a59d-4b7e-b89f-3dfc39353c55_800x800.jpg?v=1778204865',
    ],
    'by-use': [
      'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/BronceInteriors_WaveHandle_800x800.jpg?v=1779070566',
      'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/BronceInteriors_DoorHardware_800x800.jpg?v=1778218079',
    ],
 
    // SUB-ITEMS
    'brass':                'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/BronceInteriors_BobbinHandle_800x800.jpg?v=1779070566',
    'bronze':               'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/S2e4f0340dbe741158f9c241d4b9057a7K_800x800.jpg?v=1778204972',
    'nickel':               'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/A947bda7ee31b47409ff237dfedd1a9a3z_800x800.webp?v=1778204929',
    'black':                'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/BronceInteriors_SingleCabinetPull_800x800.jpg?v=1779070566',
    'hammered':             'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/par-handles-and-knobs-collection-236469_800x800.jpg?v=1778204930',
    'knurled':              'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/S40f756ebee8540a7ab9ff9fab1a84d0fn_800x800.jpg?v=1778204976',
    'linear':               'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/S43ec608d20e046139ba177a3d2c33059N_800x800.webp?v=1778204938',
    'smooth':               'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/main-image-5_3_462eb6cf-79f7-48c2-9150-92087e9ec73e_800x800.jpg?v=1778204848',
    'bathroom-accessories': 'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/BronceInteriors_BathroomAccessories_800x800.jpg?v=1779070566',
    'bathroom-hardware':    'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/liv-knobs-collection-221918_800x800.jpg?v=1778204893',
    'kitchen-accessories':  'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/description-image-4_63_800x800.jpg?v=1778204837',
    'kitchen-hardware':     'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/d24284a1-a59d-4b7e-b89f-3dfc39353c55_800x800.jpg?v=1778204865',
    'cabinet-hardware':     'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/BronceInteriors_WaveHandle_800x800.jpg?v=1779070566',
    'door-hardware':        'https://cdn.shopify.com/s/files/1/0771/3524/9579/files/BronceInteriors_DoorHardware_800x800.jpg?v=1778218079',
    // TO ADD LIVING LATER: 'living': 'YOUR_IMAGE_URL_HERE',
  };
 
  // ── STYLES ─────────────────────────────────────────────────────────────────
  const style = document.createElement('style');
  style.textContent = `
    .bronce-hover-panel {
      position: absolute;
      top: 0px;
      left: 300px;
      width: 150%;
      min-width: 200px;
      max-width: 1000px;
      height: 100%;
      overflow: hidden;
      pointer-events: none;
      z-index: 10;
      border-radius: 4px;
    }
    
    .mega-menu__list {
        width: 120px !important;
        min-width: 0 !important;
        height: 400px !important;
        min-height: 0 !important;
    }
 
    /* Single image (sub-items like Brass) */
    .bronce-hover-panel__img {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      opacity: 0;
      transition: opacity 0.35s ease;
    }
    .bronce-hover-panel__img.active {
      opacity: 1;
    }
 
    /* Accordion grid (category level) */
    .bronce-accordion {
      position: absolute;
      inset: 0;
      display: flex;
      flex-direction: row;
      gap: 4px;
      opacity: 0;
      transition: opacity 0.35s ease;
    }
    .bronce-accordion.active {
      opacity: 1;
    }
    .bronce-accordion__item {
      flex: 1;
      overflow: hidden;
      transition: flex 0.45s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
    }
    .bronce-accordion__item.expanded {
      flex: 6;
    }
    .bronce-accordion__item img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      transition: transform 0.45s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .mega-menu__wrapper--list {
      position: relative;
      padding-right: 57% !important;
    }
    .mega-menu__link {
        font-size: clamp(15px, 0.7vw, 20px) !important;
        letter-spacing: 0.22em !important;
    }

    .mega-menu__submenu-item {
        font-size: clamp(14px, 0.6vw, 18px) !important;
        letter-spacing: 0.22em !important;
    }
    .mega-menu__item--1 {
        width: 100% !important;
        margin-left: auto !important;
        margin-right: 0 !important;
    }
  
  `;
  document.head.appendChild(style);
 
  // ── HELPERS ────────────────────────────────────────────────────────────────
  function toHandle(text) {
    return text.toLowerCase().trim().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
  }
 
  function createPanel() {
    const panel = document.createElement('div');
    panel.className = 'bronce-hover-panel';
    return panel;
  }
 
  function createSingleImg(src) {
    const img = document.createElement('img');
    img.src = src;
    img.className = 'bronce-hover-panel__img';
    img.alt = '';
    return img;
  }
 
  // Creates an accordion row of images for category hover
  // subHandles: array of sub-item handles whose images to use
  // activeHandle: which one to expand on sub-item hover (or null for equal)
  function createAccordion(srcs) {
    const accordion = document.createElement('div');
    accordion.className = 'bronce-accordion';
 
    const items = srcs.map(src => {
      const item = document.createElement('div');
      item.className = 'bronce-accordion__item';
      const img = document.createElement('img');
      img.src = src;
      img.alt = '';
      item.appendChild(img);
      accordion.appendChild(item);
      return item;
    });
 
    // Method to expand a specific index
    accordion.expandIndex = function(index) {
      items.forEach((item, i) => {
        item.classList.toggle('expanded', i === index);
      });
    };
 
    accordion.resetExpand = function() {
      items.forEach(item => item.classList.remove('expanded'));
    };
 
    return accordion;
  }
 
  // ── INIT ───────────────────────────────────────────────────────────────────
  function init() {
    const wrappers = document.querySelectorAll('.mega-menu__wrapper--list');
 
    wrappers.forEach(wrapper => {
      const panel = createPanel();
 
      function hideAll() {
        panel.querySelectorAll('.bronce-hover-panel__img, .bronce-accordion').forEach(el => {
          el.classList.remove('active');
        });
      }
 
      // Map category handle → { accordion el, srcs }
      const categoryAccordions = {};
 
      // Category links — build accordion
      const categoryLinks = wrapper.querySelectorAll('.mega-menu__link');
      categoryLinks.forEach(link => {
        const handle = toHandle(link.textContent);
        const imgData = images[handle];
        if (!imgData || !Array.isArray(imgData)) return;
 
        const accordion = createAccordion(imgData);
        panel.appendChild(accordion);
        categoryAccordions[handle] = accordion;
 
        link.addEventListener('mouseenter', () => {
          hideAll();
          accordion.resetExpand();
          accordion.classList.add('active');
        });
      });
 
      // Sub-item links — show single image AND expand corresponding accordion slot
      const subLinks = wrapper.querySelectorAll('.mega-menu__submenu-item');
      subLinks.forEach(link => {
        const handle = toHandle(link.textContent);
        const imgData = images[handle];
        if (!imgData || Array.isArray(imgData)) return;
 
        // Find which category this sub-item belongs to
        const listItem = link.closest('.mega-menu__list-item');
        const categoryLink = listItem ? listItem.querySelector('.mega-menu__link') : null;
        const categoryHandle = categoryLink ? toHandle(categoryLink.textContent) : null;
 
        // Find accordion index — match sub-item image to accordion srcs
        let accordionIndex = -1;
        if (categoryHandle && categoryAccordions[categoryHandle]) {
          const accordion = categoryAccordions[categoryHandle];
          const categorySrcs = images[categoryHandle];
          accordionIndex = categorySrcs ? categorySrcs.indexOf(imgData) : -1;
        }
 
        // Create single image for sub-item
        const img = createSingleImg(imgData);
        panel.appendChild(img);
 
        link.addEventListener('mouseenter', () => {
          hideAll();
          // Show the category accordion with expanded slot
          if (categoryHandle && categoryAccordions[categoryHandle] && accordionIndex >= 0) {
            categoryAccordions[categoryHandle].classList.add('active');
            categoryAccordions[categoryHandle].expandIndex(accordionIndex);
          } else {
            // Fallback: just show single image
            img.classList.add('active');
          }
        });
      });
 
      wrapper.addEventListener('mouseleave', hideAll);
      wrapper.style.paddingRight = '57%';
      wrapper.appendChild(panel);
    });
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
 
})();
 